module.exports = __webpack_public_path__ + "assets/img/8.98efddf7.jpg";